<template>
  <div>
    <el-checkbox-group v-model="checkedData" @change="changeChecked">
      <el-checkbox v-for="item in checkedDataArr" :label="item.value" :key="item.value">{{
        item.label
      }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'newCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkedDataArr: this.dataSource,
      checkedData: [],
    };
  },
  methods: {
    changeChecked() {
      console.log('选中的值:', this.checkedData);
      this.$emit('change', this.checkedData);
    },
  },
};
</script>

<style>
</style>